export default __webpack_public_path__ + "static/media/main.0f02fbca.png";